import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MirrorPage from "@/components/MirrorPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

/*
 * The site is a like-for-like copy of https://childrensparliament.uk/ — every route renders the
 * original page markup + theme (see components/MirrorPage.jsx and /app/scripts/build_mirror.py).
 * /events (404 on the original) is a listing page; /drinking-water-safety (404 on the original)
 * redirects to the Water Management & Sustainability page.
 */
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/drinking-water-safety" element={<Navigate to="/water-management-sustainability" replace />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={<MirrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
